export default {"src":"/_next/static/media/Underline_03.db6c2f36.svg","height":26,"width":320,"blurWidth":0,"blurHeight":0};